import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { ServicepoolService } from '../services/servicepool.service';


import { InvoiceComponent } from '../invoice/invoice.component';

import { PrintpropositionComponent } from '../printproposition/printproposition.component';




@Component({
  selector: 'app-detail-dsashboard',
  templateUrl: './detail-dsashboard.component.html',
  styleUrls: ['./detail-dsashboard.component.css']
})
export class DetailDSashboardComponent implements OnInit {

   nomprofil : any ;
   retourClientWS : any ;

   allHabilitations : any ;
   allReportingAccess: any ;

   etatreq = "" ;
 
   toggle = [] ;
   toggle2  = [] ;
   verroux = [] ;
 
   allProfils : any ;
 
 
   toggleProfil  = [] ;
   subBlock = 0 ;
 
   choosenSupHierarch : any ;
 
   idsuphierarchique : any;
 
   idprofil : any ;
 
   primarycolor = "primary" ;//"#3f51b5" ;
 
 
   hereAreYourHabilitatations = [] ;
   hereAreYourReportAccess = [] ;

   infoscar  : any ;
   allgaranties : any ;
   garantiesNames = [] ;
 
   @ViewChild('spinnerDialog') spinnerDialog: TemplateRef<any>;
 
   spinnerDialogRef : any ;
 
 
   @ViewChild('confirmdialog') confirmDialog: TemplateRef<any>;
   confirmDialogRef : any ;
 
    souscription : any;
    avenantsYeup : any;

    choosenAvenant : any ;

    infoSup  : any ;
    categorie : any ;

    waitingARemoteResponse = false ;

    etatreqavenant  = "" ;
   
   samacaabiyoonwii : any ;
   
   constructor(public dialogRef: MatDialogRef<DetailDSashboardComponent>, public dialog: MatDialog, private configServer: ServicepoolService, 
           private _adapter: DateAdapter<any>, @Inject(MAT_DATE_LOCALE) private _locale: string,
           @Inject(MAT_DIALOG_DATA) public data: any ) {
 
      this.souscription = data.element;
      console.log("The souscription: ", this.souscription) ;
      this.avenantsYeup = data.avenantsYeup ;

      this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii") ;
      let profil = sessionStorage.getItem("profil") ;
      let compliances = sessionStorage.getItem("compliances") ;

      this.infoSup = JSON.parse(this.souscription.infoSup) ;
      this.categorie = this.infoSup.categorie ;

   }
 
 
   ngOnInit(): void {
    //  this.getAllProfils() ;
    console.log("Detail Souscription: ", this.souscription);
    this.getInfosCar();
   }
 
 
   getInfosAssur(){
     return JSON.parse( this.souscription.nomAssure ).prenom+" "+JSON.parse( this.souscription.nomAssure ).nom ;
   }


  consulter(faneLa){
    window.open(faneLa ) ;
  }


  parseThisElt(elt){
    return JSON.parse(elt) ;
  }


  getInfosCar(){
    this.configServer.getInfosCar("1", this.souscription.immatricule).then( (retourbi) => {
    this.retourClientWS = retourbi ;
    this.infoscar = this.retourClientWS ; 
    this.getgarantiesbypolicerf() ;
    }) ;    
  }


  chooseThisAvenant(nomAvenant){
    this.choosenAvenant = nomAvenant ;
    this.waitingARemoteResponse = false ;
    this.etatreqavenant = '' ;
    this.openConfirmDialog() ;
  }


  truncateString(leString){
    if(leString.length<=11)
      return leString ;

    return leString.substring(0, 12)+"..." ;
  }


  getgarantiesbypolicerf(){

    this.configServer.getgarantiesbypolicerf("samacaabiyoonwii", this.souscription.refPolice).then( (retourbi) => {
    this.retourClientWS = retourbi ;
    this.allgaranties = this.retourClientWS.data ; 
    this.garantiesNames = JSON.parse(this.allgaranties.garanties) ;
    console.log("GARANTIES", this.garantiesNames) ;
    }) ;    
  }


  toNumberForHtml(intrant){
    return Number(intrant) ;
  }


   close(){
     this.dialogRef.close() ;
   }


   getAllHabilitations(){
     console.log("Here we go !!!") ;
     this.configServer.getAllHabilitations("thiswii").then( (retourbi) => {
       this.retourClientWS = retourbi ;
       var statutreq = this.retourClientWS.statutreq;
       console.log(this.retourClientWS.data) ;
       if(statutreq==1){
         console.log("Done") ;
         this.allHabilitations = this.retourClientWS.data.habilitation ; 
         this.allReportingAccess = this.retourClientWS.data.reportaccess ; 
 
         for (var i = 0; i < this.allHabilitations.length; i++) {
           let oneHabilitationState = {"nom":this.allHabilitations[i].nom, "idhabilit":this.allHabilitations[i].idlignehabilit, "etat": 0 };
           this.hereAreYourHabilitatations.push(oneHabilitationState) ;
         }        
 
 
         for (var i = 0; i < this.allReportingAccess.length; i++) {
           let oneReportHabilitationState = {"nom":this.allReportingAccess[i].nom, "idhabilit":this.allReportingAccess[i].idlignehabilit, "etat": 0 };
           this.hereAreYourReportAccess.push(oneReportHabilitationState) ;
         }        
 
       }
       else{
         console.log("Failed") ;
       }
     }) ;      	
   }
 
 
   valideretsauvegarder(){
 
     //this.closeConfirmDialog() ;
     //this.openSpinnerDialog();
     this.waitingARemoteResponse = true ;
     this.configServer.checkavenant(this.samacaabiyoonwii, this.souscription.nomcompagnie, 
              this.categorie, this.choosenAvenant, this.infoSup).then( (retourbi) => {

       this.waitingARemoteResponse = false ;

       this.retourClientWS = retourbi ;
       var statutreq = this.retourClientWS.statutreq;
       console.log(this.retourClientWS.data) ;
 
       //this.closeSpinnerDialog() ;
       if(statutreq==1){
         if(this.getValeur(this.retourClientWS.data, "Conditions")==0)
           this.etatreqavenant = "failed" ;
         if(this.getValeur(this.retourClientWS.data, "Conditions")==-1)
           this.etatreqavenant = "failed" ;
         else
           this.etatreqavenant = "successful" ;
       }
       else{
         this.etatreqavenant = "failed" ;
         console.log("Failed") ;
       }
     }) ;    
   }
   

   getValeur(data, wanted){
     for (var i = 0; i < data.length; i++) {
        if(data[i].nomvariable==wanted)
          return data[i].valeur ;
     }
   }
 
   getAllProfils(){
     this.configServer.getAllProfils(this.samacaabiyoonwii).then( (retourbi) => {
       this.retourClientWS = retourbi ;
       var statutreq = this.retourClientWS.statutreq;
 
       if(statutreq==1){
         console.log(this.retourClientWS.data ) ;
         console.log("Done") ;
         this.allProfils = this.retourClientWS.data ; 
       this.setChoosenProfilSup() ;
       }
       else{
         console.log("Failed") ;
       }
     }) ;    
   }
 
   setChoosenProfilSup(){
     console.log(this.allProfils) ;
     console.log(this.idsuphierarchique);
 
     for (var i = 0; i < this.allProfils.length; i++) {
       if(this.allProfils[i].idprofil==this.idsuphierarchique)
         this.choosenSupHierarch = this.allProfils[i] ;
     }
 
   }
 
   getThePrimaryColor(idInProfil){
     if(this.choosenSupHierarch!=undefined){
       let valuReturn = this.choosenSupHierarch.idprofil==idInProfil ? this.primarycolor:'' ;
       return valuReturn ;      
     }
 
     return "" ;      
   }
 
 
   clickOnThis(ind){
     if(this.hereAreYourHabilitatations[ind].etat == 1){
       for (var i = 0 ; i <this.hereAreYourHabilitatations.length; i++) {
         console.log("Adding ...") ;
         if(i==ind){
           this.hereAreYourHabilitatations[i].etat = 0;
         }
       }
     }else{
       for (var i = 0 ; i <this.hereAreYourHabilitatations.length; i++) {
         console.log("Removing ...") ;
         if(i==ind){
           this.hereAreYourHabilitatations[i].etat = 1;
         }
       }
     }
   }


 openDialogDetailOpFact(arg): void {  


   this.souscription.attestationNumber = JSON.parse(this.souscription.infoDiotali).attestationNumber ;

    let assure  = {"marque": this.infoscar.Marque, "modele":this.infoscar.Appelation, 
                    "prenomassure":JSON.parse( this.souscription.nomAssure ).prenom, "nomassure":JSON.parse( this.souscription.nomAssure ).nom, "montant":this.souscription.primeTTC} ;
    let passedValues = {'element':this.souscription,'souscription':arg, 'assure': assure, 'datecreation':this.souscription.jour} ;

    const dialogRef = this.dialog.open(InvoiceComponent, {
      data: passedValues, disableClose:true, width:'100%'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });    
  }


 openDialogPropsPrint(arg): void {  
     let bigCategorie = JSON.parse(this.souscription.infoSup).categorie ;

     this.souscription.nombrePlace = this.infoscar.NombredePlace ;

    let assure  = {"marque": this.infoscar.Marque, "modele":this.infoscar.Appelation, 
                    "prenomassure":JSON.parse( this.souscription.nomAssure ).prenom, 
                      "nomassure":JSON.parse( this.souscription.nomAssure ).nom, 
                        "montant":this.souscription.primeTTC, 'categ': bigCategorie} ;

    let passedValues = {'element':this.souscription,'souscription':arg, 'assure': assure, 'datecreation':this.souscription.jour} ;

    const dialogRef = this.dialog.open(PrintpropositionComponent, {
      data: passedValues, disableClose:true, width:'100%'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });    
  }
 
 
   clickOnThisRep(ind){
     if(this.hereAreYourReportAccess[ind].etat == 1){
       for (var i = 0 ; i <this.hereAreYourReportAccess.length; i++) {
         console.log("Adding ...") ;
         if(i==ind){
           this.hereAreYourReportAccess[i].etat = 0;
         }
       }
     }else{
       for (var i = 0 ; i <this.hereAreYourReportAccess.length; i++) {
         console.log("Removing ...") ;
         if(i==ind){
           this.hereAreYourReportAccess[i].etat = 1;
         }
       }
     }
   }
 
 
   openConfirmDialog() {
     this.confirmDialogRef = this.dialog.open(this.confirmDialog);
   }
 
   closeConfirmDialog() {

     this.confirmDialogRef.close();
   }
 
   clickOnThisProfil(ind){
     this.choosenSupHierarch = this.allProfils[ind];
   }
 
 
   openSpinnerDialog() {
     this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
   }
 
   closeSpinnerDialog() {
     this.spinnerDialogRef.close();
   }
 
}
